import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { IntelligenceDiagram } from './IntelligenceDiagram';
import { easeOutStrong } from '../../utils/motion';
export function HomeHero() {
  const scrollToWork = () => {
    document.getElementById('what-we-build')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-white border-b border-line pt-32 pb-20 lg:pt-44 lg:pb-28" data-id="element-496" data-mp="296n5moxx0hpb">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-10 items-center" data-id="element-497" data-mp="2wuwwi59zjvnb">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: easeOutStrong
      }} className="lg:col-span-7" data-id="element-498" data-mp="2n4bpbtg8xiss">
          <h1 className="font-heading font-extrabold text-5xl sm:text-6xl lg:text-7xl text-ink-dark leading-[1.03] tracking-tight" data-id="element-499" data-mp="3ft97zxoddhm2">
            Building Intelligence in the World
          </h1>
          <p className="mt-8 text-xl lg:text-2xl text-ink-dark/80 leading-relaxed max-w-2xl" data-id="element-500" data-mp="ov8rx6r3q7rv">
            SyNeural builds systems that help people develop sound judgment,
            researchers connect ideas, and organizations turn knowledge into
            action. We bring connected knowledge and human capability together
            to support discovery, collaboration, and better decisions.
          </p>
          <p className="mt-5 text-base lg:text-lg text-ink-muted leading-relaxed max-w-2xl" data-id="element-501" data-mp="17l77s9155562">
            Our Semantic Knowledge Platform organizes knowledge and makes its
            sources and relationships easier to explore. Our Human Capability
            Framework, including CJI and NCJI, defines assessment, development,
            and readiness. Noetivra makes these resources accessible through a
            visual, interactive workspace.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4" data-id="element-502" data-mp="3ifumkv6164he">
            <button type="button" onClick={scrollToWork} className="inline-flex items-center justify-center gap-2 bg-navy hover:bg-navy-light text-white font-medium px-6 py-3.5 rounded-md transition-colors duration-150 shadow-sm whitespace-nowrap" data-id="element-503" data-mp="3edhq6xd6bixa">
              Explore Our Work
              <ArrowRight size={18} data-id="element-504" data-mp="1rc2tawf8shp9" />
            </button>
            <a href="/contact" className="inline-flex items-center justify-center border border-navy text-navy hover:bg-surface-muted font-medium px-6 py-3.5 rounded-md transition-colors duration-150 whitespace-nowrap" data-id="element-505" data-mp="1w9ks3tzjpgjj">
              Start a Conversation
            </a>
          </div>
        </motion.div>

        <div className="lg:col-span-5" data-id="element-506" data-mp="2ezaxfb0xpkpp">
          <IntelligenceDiagram data-id="element-507" data-mp="2ey98c2n32xoz" />
        </div>
      </div>
    </section>;
}